import {
    Component,
    forwardRef,
    ContentChildren,
    QueryList,
    AfterContentInit,
    Input,
    Output,
    EventEmitter
} from "@angular/core";
import {Tab, TabHeader, TabBody} from "./tab.component";


export class Tabs implements AfterContentInit {

     public type: string = "tabs";
     public openedTab: string;
     public tabChange: EventEmitter<TabChangeEvent> = new EventEmitter<TabChangeEvent>();
     public contentChange: EventEmitter<Array<TabState>> = new EventEmitter<Array<TabState>>();

     private tabs: QueryList<Tab> = new QueryList<Tab>();

    ngAfterContentInit(): any {
        this.tabChange.emit({prev: undefined, current: this.openedTab});
        this.onContentChange();
        this.tabs.changes.subscribe(() => {
            this.onContentChange();
        });
    }

    open(name: string): void {
        let tab: Tab = this.getTabByName(name);
        if (tab) {
            this.openedTab = tab.name;
        }
    }

    private getTabByName(name: string): Tab {
        let matchingTabs: Array<Tab> = this.tabs.filter(tab => tab.name === name);
        return matchingTabs.length ? matchingTabs[0] : null;
    }

    private onContentChange(): void {
        this.contentChange.emit(this.tabs.map(tab => {
            return {name: tab.name, disabled: tab.disabled};
        }));
    }

    private _open(tab: Tab): void {
        if (tab.disabled) return;
        this.tabChange.emit({prev: this.openedTab, current: tab.name});
        this.openedTab = tab.name;
    }

    private isOpened(name: string): boolean {
        return name === this.openedTab;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "a2-tabs",
    templateUrl: "src/bootstrap/tabs/tabs.component.html"
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'type': [{ type: Input },],
'openedTab': [{ type: Input },],
'tabChange': [{ type: Output },],
'contentChange': [{ type: Output },],
'tabs': [{ type: ContentChildren, args: [forwardRef(() => Tab), ] },],
};
}

export interface TabChangeEvent {
    prev: string;
    current: string;
}

export interface TabState {
    name: string;
    disabled: boolean;
}

export const TABS_DIRECTIVES: Array<any> = [Tabs, Tab, TabHeader, TabBody];

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
